import React, { useState } from 'react';
import { Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { formatSets, playerName } from '../../shared/utils/league-feed';

const MAX_ROWS = 3;

type Props = {
  // Bu hafta oynanan, izleyicinin oynamadığı ve henüz tebrik etmediği maç sonuçları (yeniden eskiye).
  events: LeagueFeed.Event[];
  // eslint-disable-next-line no-unused-vars -- callback type signature
  onCongrats: (event: LeagueFeed.Event) => Promise<boolean>;
  // eslint-disable-next-line no-unused-vars -- callback type signature
  onOpen: (event: LeagueFeed.Event) => void;
};

/**
 * LG-66: tebrik bekleyen maçlar. Akış uzadığında bu haftanın tebrik edilmemiş maçları üstte kısa
 * liste; her satırda tek dokunuşla 👏 (mevcut tebrik API'si), satıra dokununca karta gidilir.
 * Tek maç varsa kartın kendisi yeterli, liste gösterilmez. Başarı sunucu onayından sonra.
 */
export default function FeedMatchCatchUp({ events, onCongrats, onOpen }: Props) {
  const { t } = useTranslation('leagues');
  const [done, setDone] = useState<string[]>([]);
  const [busy, setBusy] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  // Tebrik edilen satır, üst liste güncellense de "tebrik ettin" olarak kalır.
  const [kept, setKept] = useState<LeagueFeed.Event[]>([]);
  const rows = [...kept, ...events.filter(event => !kept.some(item => item.id === event.id))].slice(0, MAX_ROWS);
  if (events.length + kept.length < 2) return null;

  const congrats = async (event: LeagueFeed.Event) => {
    setBusy(event.id);
    setFailed(false);
    const ok = await onCongrats(event);
    setBusy(null);
    if (ok) {
      setKept(current => [...current, event]);
      setDone(current => [...current, event.id]);
    } else setFailed(true);
  };

  return (
    <section className="feed-catchup" aria-labelledby="feed-catchup-title">
      <h3 id="feed-catchup-title">{t('detail.feed.catchUpTitle', { count: events.length + kept.length })}</h3>
      <ul>
        {rows.map(event => {
          const { veri } = event;
          const score = formatSets(veri.setler) || '—';
          return (
            <li key={event.id}>
              <button type="button" className="feed-catchup__match" onClick={() => onOpen(event)}>
                <strong>{playerName(veri.kazanan)}</strong> – {playerName(veri.kaybeden)}{' '}
                <span className="feed-catchup__score">{score}</span>
              </button>
              {done.includes(event.id) ? (
                <span className="feed-catchup__done" role="status">
                  <CheckOutlined aria-hidden="true" /> {t('detail.feed.catchUpDone')}
                </span>
              ) : (
                <Button
                  className="feed-catchup__clap"
                  loading={busy === event.id}
                  disabled={!!busy && busy !== event.id}
                  onClick={() => congrats(event)}
                  aria-label={t('detail.feed.catchUpCongrats', { name: playerName(veri.kazanan) })}
                >
                  <span aria-hidden="true">👏</span>
                </Button>
              )}
            </li>
          );
        })}
      </ul>
      {failed && (
        <p className="feed-catchup__error" role="alert">
          {t('detail.feed.congratsError')}
        </p>
      )}
    </section>
  );
}
